import { STYLE_KEYWORDS } from '../types';

/**
 * Automatically detect the best email style based on story content
 * @param {string} story - The user's story input
 * @returns {string} - The suggested email style
 */
export function detectEmailStyle(story) {
  if (!story || story.trim().length === 0) {
    return 'Everyday Insight'; // Default fallback
  }

  const storyLower = story.toLowerCase();
  const scores = {};

  // Calculate scores for each style based on keyword matches
  Object.entries(STYLE_KEYWORDS).forEach(([style, keywords]) => {
    scores[style] = keywords.reduce((score, keyword) => {
      return score + (storyLower.includes(keyword) ? 1 : 0);
    }, 0);
  });

  // Find the style with the highest score
  const maxScore = Math.max(...Object.values(scores));
  const suggestedStyle = Object.keys(scores).find(style => scores[style] === maxScore);

  // If no clear winner, default to Everyday Insight
  return maxScore > 0 ? suggestedStyle : 'Everyday Insight';
}

/**
 * Get a confidence score for the style detection (0-1)
 * @param {string} story - The user's story input
 * @param {string} style - The detected style
 * @returns {number} - Confidence score between 0 and 1
 */
export function getStyleConfidence(story, style) {
  if (!story || story.trim().length === 0) {
    return 0;
  }

  const storyLower = story.toLowerCase();
  const keywords = STYLE_KEYWORDS[style] || [];
  const matches = keywords.filter(keyword => storyLower.includes(keyword)).length;
  
  return Math.min(matches / keywords.length, 1);
} 